import { isEmpty } from "lodash"
import React, { useEffect } from "react"
import { Alert, Button } from "reactstrap"
import classNames from "classnames"
import { getApprovesTeamsReport } from "store/actions"
import { useDispatch } from "react-redux"
import moment from "moment"

const ReportButtonProject = ({
  getUnVerifiedErrorLists,
  getErrorListsUnSubmitted,
  getOnEvaluationErrorList,
  noRowsSelected,
  splittedStatusName,
  accessgroupname,
  onClickSubmitButton,
  ExcludeNonReportFunction,
  selectedArrayLists,
  setSelectedArrayLists,
  list,
  isMobile,
  isDateLessThanCurrent,
  onClickQuickSendToClient,
}) => {

  const dispatch = useDispatch()

  useEffect(() => {
    setSelectedArrayLists(list)
  }, [])

  const approveAllEvaluation = () =>{  
    const startDate = moment(list[0]?.date).format("YYYY-MM-DD")
    const param = {
      accountid: list[0]?.accountId,
      projectId: list[0]?.projectId,
      date: startDate,
      approvedByUserId: JSON.parse(localStorage.getItem("authUser") || "{}")?.data?.id,
    }         
    dispatch(getApprovesTeamsReport(param))
  }
  
  return (
    <div>
      {!isEmpty(getUnVerifiedErrorLists) && (
        <>
          <div>
            <Alert color="danger">
              <i className="mdi mdi-alert-outline me-3" />
              {`Screens not verified by `}
              {(getUnVerifiedErrorLists || []).map((item, index) => {
                return (
                  <span key={index}>
                    {item?.userName}{" "}
                    <>
                      {(getUnVerifiedErrorLists || [])?.length - 1 != index && (
                        <span>,</span>
                      )}
                    </>{" "}
                  </span>
                )
              })}
            </Alert>
          </div>
        </>
      )}
      {!isEmpty(getErrorListsUnSubmitted) && (
        <>
          <div>
            <Alert color="danger">
              <i className="mdi mdi-alert-outline me-3" />
              {` Report not submitted by `}
              {(getErrorListsUnSubmitted || []).map((item, index) => {
                return (
                  <span key={index}>
                    {item?.userName}{" "}
                    <>
                      {(getErrorListsUnSubmitted || [])?.length - 1 !=
                        index && <span>,</span>}
                    </>{" "}
                  </span>
                )
              })}
            </Alert>
          </div>
        </>
      )}
      {!isEmpty(getOnEvaluationErrorList) && (
        <>
          <div>
            <Alert color="danger">
              <i className="mdi mdi-alert-outline me-3" />
              {` On Evaluation hours submitted by `}
              {(getOnEvaluationErrorList || []).map((item, index) => {
                return (
                  <span key={index}>
                    {item?.userName}{" "}
                    <>
                      {(getOnEvaluationErrorList || [])?.length - 1 !=
                        index && <span>,</span>}
                    </>{" "}
                  </span>
                )
              })}
            </Alert>
          </div>
        </>
      )}
      {noRowsSelected && (
        <Alert color="danger" role="alert">
          Please select atleast one user
        </Alert>
      )}

      <div
        className={` flex-row align-items-center justify-content-between ${
          isMobile ? "d-block" : "d-flex"
        }`}
      >
        <div className={classNames("text-start pb-2 report-status")}>
          <div className={classNames("report-status-text")}>
            Report Status :
          </div>
          <div
            className={classNames(
              splittedStatusName !== "Submitted"
                ? "text-warning"
                : "text-success",
              "report-status-text"
            )}
          >
            {splittedStatusName}
          </div>
        </div>
        <div className="text-end pb-2">
          {!isEmpty(getOnEvaluationErrorList) && <Button
            onClick={() => {approveAllEvaluation()}}
            className="btn btn-secondary  mb-2 me-2"
          >
            Approve All Eval Hours
          </Button>}
          {isDateLessThanCurrent !== list?.[0]?.timeSummaryDate && (
              <Button
                onClick={() => onClickQuickSendToClient(selectedArrayLists)}
                disabled={
                  !isEmpty(getErrorListsUnSubmitted) ||
                  !isEmpty(getUnVerifiedErrorLists) ||
                  !isEmpty(getOnEvaluationErrorList) ||
                  noRowsSelected
                }
                className="btn btn-primary btn mb-2 me-2"
              >
                Quick Send
              </Button>
            )}
          <Button
            onClick={() => setSelectedArrayLists(list)}
            className="btn btn-danger  mb-2 me-2"
          >
            Select All
          </Button>
          <Button
            onClick={() => ExcludeNonReportFunction()}
            className="btn btn-secondary  mb-2 me-2"
          >
            Exclude Non-Reporters
          </Button>
          <Button
            onClick={() => onClickSubmitButton(selectedArrayLists)}
            disabled={
              !isEmpty(getErrorListsUnSubmitted) ||
              !isEmpty(getUnVerifiedErrorLists) ||
              !isEmpty(getOnEvaluationErrorList) ||
              noRowsSelected
            }
            className="btn btn-primary btn mb-2 me-2"
          >
            Submit Reports
          </Button>
        </div>
      </div>
    </div>
  )
}
export default ReportButtonProject
